import { fromJS } from 'immutable'
import nprogress from 'nprogress'

const initialState = fromJS({
  initialized: false,
})

export default function app(state = initialState, action) {
  // catch the _REQ, _SUCC, _FAIL action types
  // to be able to set the nprogress
  // and catch if status becomes 401 - which means jwt token has expired
  const pending = /.*_REQ$/
  const failed = /.*_FAIL$/
  const succeeded = /.*_SUCC$/

  // start nprogress if pending
  if (action.type.match(pending)) {
    nprogress.start()
    // stop nprogress if error on preflight
    if (action.error) {
      nprogress.done()
    }
  }

  if (action.type.match(failed) || action.type.match(succeeded)) {
    nprogress.done()
  }

  switch (action.type) {
    // upon entering the admin
    // set the initialized to true
    case 'ADMIN_INIT':
      return state.set('initialized', true)

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/containers/App/reducer.js